import httpClient from "../httpClient"

export const END_POINT = {
  GET_PURCHASE: "/kiban/api/analytics/purchase/:transactionId",
  GET_ESTIMATE: "/kiban/api/analytics/estimate/:transactionId",
} as const

export type AnalyticsPurchase = {
  transaction_id: string
  value: number
  tax: number
  items: {
    item_name?: string
    item_variant?: string
    price: number
    coupon?: string
    discount?: number
  }[]
}

export type AnalyticsEstimate = {
  value: number
  product_type?: string
}

const analyticsApi = {
  getPurchase(transactionId: string) {
    return httpClient.get<AnalyticsPurchase>(END_POINT.GET_PURCHASE, {
      pathParams: { transactionId },
    })
  },
  getEstimate(transactionId: string) {
    return httpClient.get<AnalyticsEstimate>(END_POINT.GET_ESTIMATE, {
      pathParams: { transactionId },
    })
  },
} as const

export default analyticsApi
